import { Component } from 'react';
class KeyRatiosMobile extends Component<any> {
  private getInsightPara(insight: any) {
    const betterCategory = (
      <div
        className={`lil-flex lil-mb-4 lil-mt-8 lil-p-1 lil-pl-4 lil-rounded-xl lil-text-s-12 lil-w-10/12`}
        style={{ border: '1.2px solid #DBF0E9' }}
      >
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1638770309_thumbsup1.png"
          alt=""
          className="lil-h-5 lil-pr-2"
        />
        <span style={{ color: '#30A882' }}>Better than category avg</span>
      </div>
    );

    const worseCategory = (
      <div
        className={` lil-flex lil-mb-4 lil-mt-8 lil-p-1 lil-pl-4 lil-rounded-xl lil-text-s-12 lil-w-10/12`}
        style={{ border: '1.2px solid #FAE7E5' }}
      >
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1638770301_thumbsup.png"
          alt=""
          className="lil-h-5 lil-pr-2"
        />
        <span style={{ color: '#D0483D' }}>Worse than category avg</span>
      </div>
    );
    switch (insight.type) {
      case 'ALPHA':
      case 'SHARPE':
        if (insight.fund > insight.catgory) {
          return betterCategory;
        } else {
          return worseCategory;
        }

      case 'BETA':
      case 'CAPTURE':
        if (insight.fund < insight.catgory) {
          return betterCategory;
        } else {
          return worseCategory;
        }
    }
  }
  private getCategoryClass(insights: any) {
    switch (insights.type) {
      case 'ALPHA':
      case 'SHARPE':
        if (insights.fund > insights.catgory) {
          return { color: '#30A882' };
        } else {
          return { color: '#D0483D' };
        }
      case 'BETA':
      case 'CAPTURE':
        if (insights.fund < insights.catgory) {
          return { color: '#30A882' };
        } else {
          return { color: '#D0483D' };
        }
      default:
        break;
    }
  }

  public render() {
    const insights = this.props.insights;
    return insights.map((ele, index) => {
      return (
        <div
          className={`lg:lil-hidden ${
            index === insights.length - 1 ? '' : 'lil-border-b-lg'
          } lil-border-grey-300 lil-p-4 md:lil-hidden xl:lil-hidden`}
        >
          <span className="lil-border-b-sm lil-border-dashed lil-border-grey-150 lil-font-semibold lil-text-s-14 lil-pb-2 lil-text-font-500">
            {ele.title}
          </span>
          {this.getInsightPara(ele)}
          <p className="lil-text-s-14">{ele.message}</p>
          <div className="lil-flex lil-mt-6">
            <div className="lil-mr-12 lil-mr-10">
              <p className="lil-text-s-12">This fund</p>
              <p
                className={`lil-font-bold `}
                style={this.getCategoryClass(ele)}
              >
                {ele.fund}
              </p>
            </div>
            <div>
              <p className="lil-text-s-12">Category avg.</p>
              <p className="lil-font-bold lil-text-font-500">{ele.catgory}</p>
            </div>
          </div>
        </div>
      );
    });
  }
}

export default KeyRatiosMobile;



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/keyRatios/keyRatiosMobile.tsx